import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AppPreInstallView from './AppPreInstallView'
import AppInstalledView from './AppInstalledView'
import { fetchAppTestToken } from 'api/developerApi'
import ConditionalRender from 'components/ConditionalRender'
import TestingTips from './TestingTips'
import { Loader } from '@driftt/tide-core'

import dividerSrc from '../divider.svg'
import './style.css'


class AppInstallView extends Component {

  static propTypes = {
    appId: PropTypes.string.isRequired,
    showErrorNotification: PropTypes.func.isRequired
  }

  state = {
    isFetchingToken: false,
    hasErrored: false,
    token: ''
  }

  fetchToken = () => {
    const { appId } = this.props
    const onDone = (token) => this.setState({ token, hasSucceeded: true })
    const onError = (error) => {
      this.setState({ hasErrored: true })
      this.props.showErrorNotification('We couldn’t fetch your access token. Please refresh the page.')
    }
    const onFinally = () => this.setState({ isFetchingToken: false })

    const onStateSet = () => fetchAppTestToken(appId)
      .then(onDone)
      .catch(onError)
      .then(onFinally)

    this.setState({ isFetchingToken: true }, onStateSet)
  }

  componentDidMount() {
    this.fetchToken()
  }

  setToken = (token) => {
    this.setState({ token })
  }

  clearToken = () => {
    this.setState({ token: null })
  }

  render() {
    const { appId, showErrorNotification } = this.props
    const { token, isFetchingToken, hasErrored, hasSucceeded } = this.state

    return (
      <div className="app-install-view">
        <ConditionalRender condition={hasSucceeded && !token}>
          <AppPreInstallView
            appId={appId}
            setToken={this.setToken}
            showErrorNotification={showErrorNotification}
          />
        </ConditionalRender>
        <ConditionalRender condition={isFetchingToken || token}>
          <AppInstalledView
            appId={appId}
            token={token}
            clearToken={this.clearToken}
            isInitializing={isFetchingToken || hasErrored}
            showErrorNotification={showErrorNotification}
          />
        </ConditionalRender>
        <img
          className="app-oauth-divider"
          src={dividerSrc}
          alt="divider"
        />
        <ConditionalRender
          condition={isFetchingToken}
          className="app-install-view-loader">
          <Loader />
        </ConditionalRender>
        <ConditionalRender
          condition={!isFetchingToken}
          className="app-install-testing-section">
          <TestingTips />
        </ConditionalRender>

      </div>
    )
  }
}

export default AppInstallView
